import React from 'react'
import PropTypes from 'prop-types'
import { MetaTags } from "react-meta-tags"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import StockInForm from "../../containers/stock-in/StockInForm"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import { addNewStockIn } from "../../store/stock-in/actions"

const AddNewStockIn = props => {
  const { addNewStockIn, history } = props

  const handleOnSubmit = (data) => {
    addNewStockIn(data)
    history.push(`/stock-in`)
  }

  const handleOnCancel = () => {
    history.push(`/stock-in`);
  }

  return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Stock In | CR TechSoft</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs
                title="Home"
                backLink={ `/stock-in` }
                breadcrumbItem={ `Add New Stock-In` }
            />
            <Row>
              <Col md={ 12 }>
                <StockInForm onSubmit={ handleOnSubmit } onCancel={ handleOnCancel }/>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
  )
}

AddNewStockIn.propTypes = {
  addNewStockIn: PropTypes.func,
  match: PropTypes.object,
  history: PropTypes.object,
}

const mapStateToProps = ({ stockIn }) => {
  return stockIn
}

export default withRouter(
    connect(mapStateToProps, {
      addNewStockIn,
    })(AddNewStockIn)
)
